/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=f08fb79a&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=ts&"
export * from "./file-list.vue?vue&type=script&lang=ts&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=f08fb79a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08fb79a",
  null
  
)

export default component.exports